import { get } from 'lodash-es'
import { constantCase } from 'change-case'
import axios from 'axios'
import { REQUEST_STATE, SET_STATE_KEY } from './constants'
import { stringify } from 'qs'

let types = {}

const BASE_ACTIONS = {
  REQUEST: (set, { defaultUrl = {}, defaultData = {}, successTransforms = {} } = {}) => {
    const RequestCancelToken = axios.CancelToken
    return async (
      { state, commit, getters },
      {
        method = 'get',
        data = defaultData.REQUEST,
        headers = {},
        url = defaultUrl.REQUEST,
        token,
      } = {},
    ) => {
      const params = {
        method,
        url: `${url}${
          method === 'get' && data ? `${url.indexOf('?') === -1 ? '?' : '&'}${stringify(data)}` : ''
        }`,
        headers,
      }

      if (token) {
        params.headers.Authorization = `Bearer ${token}`
      }

      const cancelSource = set.cancelSourceKey ? RequestCancelToken.source() : null
      if (cancelSource) {
        params.cancelToken = cancelSource.token
      }

      if (method === 'post' && data) {
        params.data = data
      }

      if (set.promiseKey && getters[`${set.type}_PENDING`]) {
        if (set.cancelSourceKey && state[`${SET_STATE_KEY}_${set.type}`][set.cancelSourceKey]) {
          state[`${SET_STATE_KEY}_${set.type}`][set.cancelSourceKey].cancel(
            'override by new request',
          )
        }
        await state[`${SET_STATE_KEY}`][set.promiseKey]
      }

      const promise = axios(params)
        .then(response => {
          const data =
            typeof successTransforms.REQUEST === 'function'
              ? successTransforms.REQUEST(response?.data)
              : response?.data
          commit(set.type, {
            type: REQUEST_STATE.STATE_SUCCESS,
            data,
            status: response.status,
          })
          return response
        })
        .catch(error => {
          const status = get(error, 'response.status', 400)
          const errorMessage = error?.response?.data?.message || error.message
          const data = error?.response?.data || {}
          commit(set.type, {
            type: REQUEST_STATE.STATE_FAILURE,
            data,
            status: status,
            errorMessage,
          })
          // return Promise.reject(new Error(errorMessage))
          return data
        })

      commit(set.type, { type: REQUEST_STATE.STATE_PENDING, promise, cancelSource })

      return promise
    }
  },
}

export const getBaseTypes = () => types

// export const getBaseTypes = stateSets =>
//   stateSets.reduce(
//     (result, set) => ({
//       ...result,
//       ...Object.entries(BASE_ACTIONS).reduce(
//         (actionTypes, [baseType]) => ({
//           ...actionTypes,
//           [`${set.type}_${baseType}`]: `${set.type}_${baseType}`,
//         }),
//         {},
//       ),
//     }),
//     {},
//   )

export const getActions = (stateSets, setConfigs = {}) =>
  stateSets.reduce(
    (result, set) => ({
      ...result,
      ...Object.entries(BASE_ACTIONS).reduce((getters, [baseType, baseTypeFn]) => {
        const actionString = `${set.type}_${baseType}`
        const actionId = constantCase(actionString)
        types[actionId] = actionId
        return {
          ...getters,
          [actionId]: baseTypeFn(set, setConfigs[set.type]),
        }
      }, {}),
    }),
    {},
  )
